import { PatientWebSettingsConfigV1, PatientWebSettingsConfigV1Schema } from '@csp/config-schemas';
import { JsonValidationService } from '@csp/csp-common-util';

const validatePatientWebSettingsConfig = (config: PatientWebSettingsConfigV1): void => {
  JsonValidationService.validateJsonNonStrict(
    'PatientWebSettingsConfig config V1',
    PatientWebSettingsConfigV1Schema,
    config,
  );
};

export const PatientWebSettingsConfigValidationService = {
  validatePatientWebSettingsConfig,
};
